import React, { Component, Fragment, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Progress from "react-svg-progress";
import I18n from "i18n-js";

import api from "../api";

import { SUPPORTED_EXTENSIONS } from "../config/resume";

import FileChooser from "../commons/FileChooser";

import Page from "./components/Page";
import ResumeDetails from "./components/ResumeDetails";

const Resume = ({ user, resume }) => {

  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState(null);

  const uploadResume = () => {
    if (!document) return;
    
    setLoading(true);

    const data = new FormData();
    data.append("resume", document);

    api.post("/users/resume", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(_ => {
      toast.success(<b>{I18n.t("common.saved_successfully")}</b>);
      reload();
    })
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(<b>{err.response.data.message}</b>);
      } else {
        toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
      }
      setLoading(false);
      console.error(err);
    });
  }

  const reload = () => window.location.reload();

  const handleCancel = () => {
    setDocument(null);
  }

  return (
    <Fragment>
      <Page
        className="resume-page"
        title={I18n.t("settings.pages.resume.title")}
        subtitle={I18n.t("settings.pages.resume.subtitle")}
        user={user}
      >
        <FileChooser
          disabled={loading}
          supportedFiles={SUPPORTED_EXTENSIONS}
          onFileSelected={setDocument}
        />
        {resume
          ? <ResumeDetails resume={resume} onResumeDeleted={reload}/>
          : null}
        <div className="separator" />
        <div className="buttons-section">
          <button
            className="cancel-btn"
            disabled={loading}
            onClick={handleCancel}
          >
            {I18n.t("settings.actions.cancel")}
          </button>
          <button
            className="save-btn"
            disabled={loading}
            onClick={() => uploadResume()}
          >
            <span className={loading ? "loading" : ""}>
              {I18n.t("settings.actions.save")}
            </span>
            <div className={loading ? "progress loading" : "progress"}>
              <Progress color="#FFFFFF" size="16px" />
            </div>
          </button>
        </div>
      </Page>
      <Toaster
        position="top-right"
        reverseOrder
      />
    </Fragment>
  );
}

// NOTE: needed now to current version of ReactOnRails to work with hooks
export default class ResumeComponent extends Component {
  render() {
    return <Resume {...this.props} />;
  }
}
